<template>

    <div class="d-flex flex-column" v-bind:class="{ 'flex-lg-row': (labelSide!=='top') }">
        <div class="pr-md-3">
            <div class="font-weight-normal line-height-2 text-gray m-0">
                {{ label }}
            </div>
        </div>
        <div>
            <input-switch
                v-bind="getInputProps({

                })"

                color="gradient-blue"
                v-model="inputValue"
            >
                <template #hidden="{ checked }">
                    <input type="hidden" :name="name" :value="checked ? checkedValue : uncheckedValue">
                </template>
                <template #next="{ checked }">
                    <div class="position-relative d-inline-block float-right px-4 py-3">
                        <span class="fit text-gray font-weight-normal text-capitalize line-height-2 text-center m-0">
                            <template v-if="checked">
                                {{ checkedLabel }}
                            </template>
                            <template v-else>
                                {{ uncheckedLabel }}
                            </template>
                        </span>
                    </div>
                </template>
            </input-switch>
        </div>
    </div>


</template>

<script>
    import mixinCommon from './mixinCommon';
    import mixinInput from './mixinInput';

    import InputSwitch from './InputSwitch'

    export default {
        mixins: [ mixinCommon, mixinInput ],
        components: {
            'input-switch': InputSwitch
        },
        props: {
            ...InputSwitch.props,

            name: {
                type: String,
                default: ''
            },

            label: {
                type: String,
                default: ''
            },
            labelSide: {
                type: String,
                default: 'left'
            },

            checkedLabel: {
                type: String,
                default: 'yes'
            },
            uncheckedLabel: {
                type: String,
                default: 'no'
            },
            checkedValue: {
                type: [String, Number],
                default: 1
            },
            uncheckedValue: {
                type: [String, Number],
                default: 0
            }
        },
        data() {
            return {

            };
        },
        computed: {
            enabled: {
                get() {
                    return this.inputValue === 'string' ? !!+this.inputValue.trim() : !!+this.inputValue;
                },
                set( enabled ) {
                    this.inputValue = enabled ? '1' : '';
                }
            }
        },
        mounted() {},
        methods: {
            getInputProps( overrideProps = {} ) {
                return this.getComponentProps( InputSwitch, overrideProps );
            }
        }
    }
</script>
